import DisciplinaryCollection from './DisciplinaryCollection';

export default DisciplinaryCollection;
